<ng-container *ngIf="exams?.length > 0; else noResults">
  <ng-container *ngFor="let el of exerciseSetEntries; let i = index; trackBy: trackByExerciseSet">
    <div class="card mb-5">
      <div class="card-header border-bottom border-secondary pb-4">
        <h5 class="mb-0">
          <h5>{{ el[0].name }}</h5>
        </h5>
      </div>
      <div class="card-body">
        <div class="accordion accordion-flush" [id]="'examsList' + i">
          <div *ngFor="let exam of el[1]; let j = index; trackBy: trackByExamSession" class="accordion-item mb-3">
            <h2 class="accordion-header" [id]="'heading' + i + j">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#collapse' + i + j" aria-expanded="true"
                      [attr.aria-controls]="'collapse' + i + j">
                {{ exam.chapterName }} {{ exam.examName }} - {{ getExamScore(exam) | percent }}
              </button>
            </h2>
            <div [id]="'collapse' + i + j" class="accordion-collapse collapse"
                 [attr.aria-labelledby]="'heading' + i + j"
                 [attr.data-bs-parent]="'#examsList' + i">
              <div class="accordion-body p-2">
                <div class="accordion" id="examsPartList">
                  <div *ngFor="let examPart of getExamParts(exam); let i = index; trackBy: trackByExamPart" class="accordion-item mb-2">
                    <app-exam-part-result
                      [examPart]="examPart"
                      [personId]="student?.person?.id"
                      [examSessionUuid]="exam.uuid">
                    </app-exam-part-result>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-template #noResults>
  <p class="text-center fs-5 text-muted m-0">
    {{ 'LESSONS.NO_RESULTS' | translate }}
  </p>
</ng-template>
